const COLUMN_1 = {
    column: 1,
};

const COLUMN_2 = {
    column: 2,
};

export default Object.freeze({
    'Visitor Overview': COLUMN_1,
    'Account Overview': COLUMN_2,
    'Weekly Visitors': COLUMN_1,
    'Weekly Accounts': COLUMN_2,
    'Browser Usage': COLUMN_1,
    'Page Overview': COLUMN_2,
    'Feature Overview': COLUMN_2,
    'Page Use by Account': COLUMN_1,
    'Feature Use by Account': COLUMN_2,
    'Active Unique Visitors Per Hour': COLUMN_1,
    'Guide Overview': COLUMN_1,
    'Most Seen Guides': COLUMN_2,
});
